import { Trophy, Star, Medal, Target, MessageSquare, Heart } from 'lucide-react'

interface Stats {
  total_points: number
  level: number
  rank: number
  total_members: number
  badges_count: number
  posts_count: number
  likes_received: number
  points_this_month: number
}

interface StatsOverviewProps {
  stats: Stats
}

export function StatsOverview({ stats }: StatsOverviewProps) {
  const items = [
    {
      icon: Star,
      label: 'Points',
      value: stats.total_points.toLocaleString('fr-FR'),
      color: 'text-orange-500'
    },
    {
      icon: Trophy,
      label: 'Niveau',
      value: stats.level,
      color: 'text-green-600'
    },
    {
      icon: Medal,
      label: 'Classement',
      value: `#${stats.rank} / ${stats.total_members}`,
      color: 'text-tessan-primary'
    },
    {
      icon: Target,
      label: 'Badges',
      value: stats.badges_count,
      color: 'text-red-500'
    },
    {
      icon: MessageSquare,
      label: 'Publications',
      value: stats.posts_count,
      color: 'text-tessan-primary'
    },
    {
      icon: Heart,
      label: 'Likes reçus',
      value: stats.likes_received,
      color: 'text-red-500'
    },
  ]

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
      {items.map((item) => (
        <div
          key={item.label}
          className="bg-white rounded-xl p-4 shadow-sm border border-gray-100"
        >
          <item.icon className={`w-6 h-6 ${item.color} mb-2`} />
          <div className="text-2xl font-bold text-gray-900">{item.value}</div>
          <div className="text-sm text-gray-500">{item.label}</div>
        </div>
      ))}
    </div>
  )
}
